import { render, staticRenderFns } from "./KETVeranstaltungDetails.vue?vue&type=template&id=01575356&"
import script from "./KETVeranstaltungDetails.vue?vue&type=script&lang=js&"
export * from "./KETVeranstaltungDetails.vue?vue&type=script&lang=js&"
import style0 from "./KETVeranstaltungDetails.vue?vue&type=style&index=0&id=01575356&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports